import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

interface Props extends React.SVGProps<SVGSVGElement> {
  theme?: 'light';
}

export default function LogoIcon({ theme: _theme, width = 24, height = 24, ...rest }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1218_18758)">
        <path
          d="M16.261 4.09888V8.03385C16.261 8.08792 16.2162 8.13272 16.1621 8.13272C13.959 8.07865 12.1823 6.30351 12.1313 4.10042C12.1298 4.04635 12.1746 4 12.2287 4H16.1636C16.2177 4 16.261 4.0448 16.261 4.09888Z"
          fill="#DC7441"
        />
        <path
          d="M6.7132 19.1049V14.3728C6.7132 14.3171 6.758 14.2739 6.81362 14.2754C9.45703 14.328 11.5891 16.4615 11.6416 19.1034C11.6431 19.159 11.5983 19.2038 11.5443 19.2038H6.81208C6.75646 19.2022 6.7132 19.159 6.7132 19.1049Z"
          fill="#301B6B"
        />
        <path
          d="M17.0767 15.1624C17.069 15.1407 17.0597 15.1206 17.052 15.099C14.7593 15.0959 12.6272 14.3992 10.8583 13.208C12.7323 14.5058 13.9667 16.6625 13.9976 19.1081C13.9976 19.1607 14.0424 19.2039 14.0949 19.2039H14.3174C16.4046 19.2024 17.8352 17.1059 17.0767 15.1624Z"
          fill="#301B6B"
        />
        <path
          d="M9.77681 4.09579C9.77526 4.04326 9.732 4 9.67948 4H9.46627C7.37906 4 5.94535 6.09958 6.70701 8.04157C6.71164 8.05393 6.71628 8.06629 6.72246 8.0802C9.01978 8.08329 11.1549 8.78315 12.9269 9.97893C11.0529 8.68427 9.81543 6.53525 9.77681 4.09579Z"
          fill="#DC7441"
        />
        <path
          d="M12.927 9.97735C11.1549 8.78156 9.0198 8.0817 6.72247 8.07861C7.55674 10.1766 9.01053 11.9611 10.8583 13.2063C12.6272 14.399 14.7577 15.0957 17.0519 15.0988C16.2192 13.0039 14.7701 11.2226 12.927 9.97735Z"
          fill="#A342A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1218_18758">
          <rect width="11" height="15.5" fill="white" transform="translate(6.5 4)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const PdfLogoIcon = ({ width = 8, height = 11 }: Props) => (
  <Svg width={width} height={height} viewBox="0 0 8 11">
    <Path
      d="M6.50731 0.398925V3.02224C6.50731 3.05829 6.47744 3.08816 6.4414 3.08816C4.97267 3.05211 3.78821 1.86868 3.75422 0.399955C3.75319 0.363907 3.78306 0.333008 3.81911 0.333008H6.44243C6.47847 0.333008 6.50731 0.362877 6.50731 0.398925Z"
      fill="#DC7441"
    />
    <Path
      d="M0.142143 10.4033V7.24851C0.142143 7.21143 0.172012 7.18259 0.209091 7.18362C1.97136 7.21864 3.39271 8.64101 3.42773 10.4022C3.42876 10.4393 3.39889 10.4692 3.36284 10.4692H0.208061C0.170982 10.4682 0.142143 10.4393 0.142143 10.4033Z"
      fill="#301B6B"
    />
    <Path
      d="M7.05112 7.77458C7.04597 7.76016 7.03979 7.74677 7.03464 7.73235C5.50618 7.73029 4.08483 7.26578 2.90552 6.47168C4.15487 7.33685 4.97781 8.77468 4.9984 10.4051C4.9984 10.4401 5.02827 10.469 5.06329 10.469H5.21161C6.60309 10.4679 7.55683 9.07027 7.05112 7.77458Z"
      fill="#301B6B"
    />
    <Path
      d="M2.18451 0.396865C2.18349 0.361847 2.15465 0.333008 2.11963 0.333008H1.97749C0.586014 0.333008 -0.36979 1.73273 0.137981 3.02739C0.141071 3.03563 0.144161 3.04387 0.148281 3.05314C1.67983 3.0552 3.10324 3.52177 4.28461 4.31896C3.03526 3.45585 2.21026 2.02318 2.18451 0.396865Z"
      fill="#DC7441"
    />
    <Path
      d="M4.28463 4.31758C3.10327 3.52039 1.67986 3.05382 0.148308 3.05176C0.704487 4.45045 1.67368 5.64005 2.90551 6.4702C4.08482 7.26534 5.50513 7.72985 7.03463 7.73191C6.47948 6.33528 5.51337 5.14773 4.28463 4.31758Z"
      fill="#A342A8"
    />
  </Svg>
);
